import { PropsLink } from './PropsLink';
import { useAppSelector } from '@redux/hooks';
import { ensureTrailingSlash } from '@sharedHelpers/ensureTrailingSlash';
import classNames from 'classnames';
import Link from 'next/link';

import styles from './Link.module.scss';

export const MyLink = ({
  href,
  children,
  type = 'link',
  appearance,
  className,
  appendTrailingSlash,
  target,
  external,
  onClick,
  ...other
}: PropsLink): JSX.Element => {
  const subdomain = useAppSelector(state => state.header.data.region.SUBDOMAIN);
  const LinkIndexRobot = (href: string): boolean => {
    const linkRegexp = /https:\/\/.+[^koleso.ru].+\./;
    return linkRegexp.test(href.replace(`${subdomain}.`, ''));
  };

  const isReload = href.includes('/catalog/') || href.includes('auto') || external;

  const finalUrl = ensureTrailingSlash(href, appendTrailingSlash);

  return !isReload ? (
    <Link href={finalUrl}>
      <a
        target={target}
        itemProp="url"
        rel={LinkIndexRobot(finalUrl) ? 'nofollow' : ''}
        className={classNames(
          styles.Link,
          className,
          type === 'button' && styles.Button,
          appearance === 'red' && styles.red,
          appearance === 'ghost' && styles.ghost,
          appearance === 'ghostRed' && styles.ghostRed,
        )}
        data-testid={other['data-testid']}
        onClick={() => onClick && onClick()}
      >
        {children}
      </a>
    </Link>
  ) : (
    <a
      href={finalUrl}
      target={target}
      itemProp="url"
      rel={LinkIndexRobot(finalUrl) ? 'nofollow' : ''}
      className={classNames(
        styles.Link,
        className,
        type === 'button' && styles.Button,
        appearance === 'red' && styles.red,
        appearance === 'ghost' && styles.ghost,
        appearance === 'ghostRed' && styles.ghostRed,
      )}
      data-testid={other['data-testid']}
      onClick={() => onClick && onClick()}
    >
      {children}
    </a>
  );
};
